export { scrambledCardStyles } from '@utils/component-framework';

const contentWrapper = "_ud7c17pavms";
const textBox = "_ud7ts8wfqh";
const line = "_ud7l105os58";

export { contentWrapper, line, textBox };
import "./comp.scrambled.style.linaria.module.css";
//# sourceMappingURL=comp.scrambled.style.js.map
